module.exports = "https://r.nearpod.com/assets/media/image/manage_icon-8898bf0d3cf96143349608debfac0dc8.svg";